import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fw-normal" }
const _hoisted_2 = {
  key: 1,
  class: "form mb-48"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "col-12 col-lg-12" }
const _hoisted_35 = { class: "col-12 col-lg-12" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "col" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-3" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = {
  key: 0,
  class: "row"
}
const _hoisted_49 = { class: "col-3" }
const _hoisted_50 = { class: "col" }
const _hoisted_51 = {
  key: 1,
  class: "row"
}
const _hoisted_52 = { class: "col-3" }
const _hoisted_53 = { class: "col" }
const _hoisted_54 = {
  key: 2,
  class: "row"
}
const _hoisted_55 = { class: "col-3" }
const _hoisted_56 = { class: "col" }
const _hoisted_57 = {
  key: 3,
  class: "row"
}
const _hoisted_58 = { class: "col-3" }
const _hoisted_59 = { class: "col" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-save fw-bold me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_title = _resolveComponent("modal-title")!
  const _component_modal_header = _resolveComponent("modal-header")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_form_group_input_date = _resolveComponent("v-form-group-input-date")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_form_group_input_checkbox = _resolveComponent("v-form-group-input-checkbox")!
  const _component_modal_body = _resolveComponent("modal-body")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_modal_footer = _resolveComponent("modal-footer")!
  const _component_v_modal = _resolveComponent("v-modal")!

  return (_openBlock(), _createBlock(_component_v_modal, {
    size: "xl",
    "class-name": "modal-fullscreen-lg-down",
    onClosed: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_modal_title, { as: "h4" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('Modificación de')), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('profesional')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_modal_body, null, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_v_loader, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("fieldset", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Tipo documento identidad'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.identityDocType
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.identityDocType}),
                            options: _ctx.formsSettings.accepted_identification_document_types,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.identityDocType,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.identityDocType) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.nif,
                        label: _ctx.$t('Nº documento identidad'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.nif,
                        autocomplete: "off",
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.nif = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Tipo de profesional'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.role
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.role}),
                            options: _ctx.roleOptions,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.role,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.role) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.name,
                        label: _ctx.$t('Nombre'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.name,
                        autocomplete: "off",
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.name = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.surname,
                        label: _ctx.$t('Apellidos'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.surname,
                        autocomplete: "off",
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.surname = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Género'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.genre
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.genre}),
                            options: _ctx.formsSettings.accepted_genre_options,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.genre,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.genre) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_form_group_input_text, {
                        type: "email",
                        value: _ctx.email,
                        label: _ctx.$t('Correo'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.email,
                        autocomplete: "off",
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.email = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Prefijo teléfono'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.phoneNumberPrefix
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.phoneNumberPrefix}),
                            options: _ctx.formsSettings.valid_phone_number_prefix_options,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.phoneNumberPrefix,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.phoneNumberPrefix) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.phoneNumber,
                        label: _ctx.$t('Nº teléfono'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.phoneNumber,
                        autocomplete: "off",
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.phoneNumber = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_v_form_group_input_date, {
                        label: _ctx.$t('Fecha de nacimiento'),
                        value: _ctx.bornDate,
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.bornDate,
                        autocomplete: "off",
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_ctx.bornDate = $event))
                      }, null, 8, ["label", "value", "yup-errors-variable"])
                    ])
                  ]),
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Dirección personal')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.personalLine1,
                        label: _ctx.$t('Dirección 1'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.personalLine1,
                        autocomplete: "off",
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.personalLine1 = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.personalLine2,
                        label: _ctx.$t('Dirección 2'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.personalLine2,
                        autocomplete: "off",
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.personalLine2 = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.personalCP,
                        label: _ctx.$t('Código postal'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.personalCP,
                        autocomplete: "off",
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.personalCP = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.personalCity,
                        label: _ctx.$t('Ciudad'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.personalCity,
                        autocomplete: "off",
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.personalCity = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.personalProvince,
                        label: _ctx.$t('Provincia'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.personalProvince,
                        autocomplete: "off",
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.personalProvince = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.personalCountry,
                        label: _ctx.$t('País'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.personalCountry,
                        autocomplete: "off",
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.personalCountry = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ]),
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Dirección profesional')), 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.professionalLine1,
                        label: _ctx.$t('Dirección 1'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.professionalLine1,
                        autocomplete: "off",
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.professionalLine1 = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.professionalLine2,
                        label: _ctx.$t('Dirección 2'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.professionalLine2,
                        autocomplete: "off",
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (_ctx.professionalLine2 = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.professionalCP,
                        label: _ctx.$t('Código postal'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.professionalCP,
                        autocomplete: "off",
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.professionalCP = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.professionalCity,
                        label: _ctx.$t('Ciudad'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.professionalCity,
                        autocomplete: "off",
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.professionalCity = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.professionalProvince,
                        label: _ctx.$t('Provincia'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.professionalProvince,
                        autocomplete: "off",
                        "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.professionalProvince = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.professionalCountry,
                        label: _ctx.$t('País'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.professionalCountry,
                        autocomplete: "off",
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (_ctx.professionalCountry = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_v_alert, {
                      variant: "secondary",
                      role: "alert"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(// eslint-disable-next-line max-len
                  _ctx.$t('Puedes permitir que este profesional cree autorizaciones de compra sin necesidad de responder anamnesis ni iniciar un tratamiento. Si este campo está marcado podrá autorizar libremente a sus pacientes.')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_v_form_group_input_checkbox, {
                      label: _ctx.$t('Permitir autorizar libremente'),
                      value: _ctx.canFreelyAuthorize,
                      class: "mb-24",
                      "for-key": "canFreelyAuthorize",
                      "yup-errors-variable": _ctx.errors.canFreelyAuthorize,
                      autocomplete: "off",
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.handleCheckboxClick($event, 'canFreelyAuthorize')))
                    }, null, 8, ["label", "value", "yup-errors-variable"])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_v_form_group_input_checkbox, {
                      label: _ctx.$t('Permitir acceso a la aplicación'),
                      value: _ctx.active,
                      "for-key": "active",
                      class: "mb-24",
                      "yup-errors-variable": _ctx.errors.active,
                      autocomplete: "off",
                      "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleCheckboxClick($event, 'active')))
                    }, null, 8, ["label", "value", "yup-errors-variable"])
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_36, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Especialidad')), 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Principal'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.speciality
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.speciality}),
                            options: _ctx.specialityOptions,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: false,
                            modelValue: _ctx.speciality,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.speciality) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.professional?.subspeciality,
                        label: _ctx.$t('Subespecialidad'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.subspeciality,
                        autocomplete: "off",
                        "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => (_ctx.subspeciality = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_40, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Colegiado')), 1),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.college,
                        label: _ctx.$t('Colegio'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.college,
                        autocomplete: "off",
                        "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => (_ctx.college = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.collegeNumber,
                        label: _ctx.$t('Número de colegiado'),
                        class: "mb-24",
                        autocomplete: "off",
                        "yup-errors-variable": _ctx.errors.collegeNumber,
                        "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => (_ctx.collegeNumber = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ])
                ]),
                _createElementVNode("fieldset", _hoisted_44, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('Otros teléfonos')), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createVNode(_component_v_form_group_select, {
                        label: _ctx.$t('Prefijo tel.'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixOne
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_select, {
                            class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixOne}),
                            options: _ctx.formsSettings.valid_phone_number_prefix_options,
                            reduce: returnValue => returnValue.key,
                            "select-on-key-codes": [188, 13],
                            clearable: true,
                            modelValue: _ctx.auxPhoneNumberPrefixOne,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.auxPhoneNumberPrefixOne) = $event))
                          }, {
                            "no-options": _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                            ]),
                            _: 1
                          }, 8, ["class", "options", "reduce", "modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "yup-errors-variable"])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_v_form_group_input_text, {
                        value: _ctx.auxPhoneNumberOne,
                        label: _ctx.$t('Teléfono'),
                        class: "mb-24",
                        "yup-errors-variable": _ctx.errors.auxPhoneNumberOne,
                        autocomplete: "off",
                        "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => (_ctx.auxPhoneNumberOne = $event))
                      }, null, 8, ["value", "label", "yup-errors-variable"])
                    ])
                  ]),
                  (_ctx.auxPhoneNumberPrefixOne && _ctx.auxPhoneNumberOne ||
             _ctx.auxPhoneNumberPrefixTwo || _ctx.auxPhoneNumberTwo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixTwo
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixTwo}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixTwo,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.auxPhoneNumberPrefixTwo) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberTwo,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberTwo,
                            autocomplete: "off",
                            "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => (_ctx.auxPhoneNumberTwo = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.auxPhoneNumberPrefixTwo && _ctx.auxPhoneNumberTwo ||
             _ctx.auxPhoneNumberPrefixThree || _ctx.auxPhoneNumberThree)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixThree
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixThree}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixThree,
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.auxPhoneNumberPrefixThree) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberThree,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberThree,
                            autocomplete: "off",
                            "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => (_ctx.auxPhoneNumberThree = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.auxPhoneNumberPrefixThree && _ctx.auxPhoneNumberThree ||
             _ctx.auxPhoneNumberPrefixFour || _ctx.auxPhoneNumberFour)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixFour
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixFour}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixFour,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.auxPhoneNumberPrefixFour) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberFour,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberFour,
                            autocomplete: "off",
                            "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => (_ctx.auxPhoneNumberFour = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.auxPhoneNumberPrefixFour && _ctx.auxPhoneNumberFour ||
             _ctx.auxPhoneNumberPrefixFive || _ctx.auxPhoneNumberFive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_v_form_group_select, {
                            label: _ctx.$t('Prefijo tel.'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberPrefixFive
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                class: _normalizeClass({'is-invalid': !!_ctx.errors.auxPhoneNumberPrefixFive}),
                                options: _ctx.formsSettings.valid_phone_number_prefix_options,
                                reduce: returnValue => returnValue.key,
                                "select-on-key-codes": [188, 13],
                                clearable: true,
                                modelValue: _ctx.auxPhoneNumberPrefixFive,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.auxPhoneNumberPrefixFive) = $event))
                              }, {
                                "no-options": _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                                ]),
                                _: 1
                              }, 8, ["class", "options", "reduce", "modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label", "yup-errors-variable"])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_v_form_group_input_text, {
                            value: _ctx.auxPhoneNumberFive,
                            label: _ctx.$t('Teléfono'),
                            class: "mb-24",
                            "yup-errors-variable": _ctx.errors.auxPhoneNumberFive,
                            autocomplete: "off",
                            "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => (_ctx.auxPhoneNumberFive = $event))
                          }, null, 8, ["value", "label", "yup-errors-variable"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_modal_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_button, {
            variant: "link-secondary",
            class: "me-24",
            "aria-label": _ctx.$t('Cancelar'),
            "data-bs-dismiss": "modal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]),
          _createVNode(_component_v_button, {
            variant: "secondary",
            class: "btn-icon",
            "aria-label": _ctx.$t('Actualizar'),
            onClick: _ctx.updateProfessional,
            "is-loading": _ctx.accepted
          }, {
            default: _withCtx(() => [
              _hoisted_60,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('Actualizar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick", "is-loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onClosed"]))
}